export default __webpack_public_path__ + "static/media/Screenshot (1142).6f7033cd.png";